module.exports = __webpack_public_path__ + "static/media/2_r_Layer2_80.89_38.33.57112a7c.png";